import React from 'react'
import FavoriteLocation from '../../../../components/Tabs/FavoriteItems/FavoriteLocation';
import { REACT_APP_CLOUD_FRONT } from '../../../../constants';
import {LocationModel} from "../../../../models/location.model";
import { Info } from '../../../../images/svgIcons/svg';

interface IActiveLocationProps {
    styleClasses: { readonly [key: string]: string }
    location: any;
    isDeviceIos:boolean;
    isGuest: boolean;
    hovered:number;
    favoriteButtonHandler:any;
    favoriteLocations:number[];
    handleSelectedLocation: (LocationModel) => void;
    getInfo: (id) => void
}

const ActiveLocation: React.FC<IActiveLocationProps> = ({ isGuest, styleClasses, location, isDeviceIos, hovered, favoriteButtonHandler, favoriteLocations, handleSelectedLocation, getInfo }) => {
    const isFavorite = () => {
        return favoriteLocations.includes(location.id);
    }
    
    const locationDistance = () => {
        if (location?.distance !== null && location?.distance !== undefined && location?.distance > 0) {
            return <React.Fragment>
                <span className={`d-block h-18 font-Visby-cf f-s12 pt-1`}>{location.distance} miles</span>
            </React.Fragment>
        }
    }
    const handleLocationSelect = (location) => {
        if( location.is_live ) handleSelectedLocation(location)
    }
  
    return (
      <div className={`${styleClasses.activeLocationCardParentContainer_mobile_designv2}`} data-testid="searched-location-items">
        <li
          className={`${styleClasses.location_card} ${styleClasses.selected_Location_card_mobile_designv2} d-flex align-items-center justify-content-between mb-3`}
          onClick={() => handleLocationSelect(location)}
        >
          <div className="d-flex gap-3 align-items-center">
            <div className={styleClasses.location_image}>
              <img
                src={
                  isDeviceIos
                    ? `${REACT_APP_CLOUD_FRONT}/Locations/` +
                      location.id +
                      "/location-" +
                      location.id +
                      ".jpeg"
                    : `${REACT_APP_CLOUD_FRONT}/Locations/` +
                      location.id +
                      "/location-" +
                      location.id +
                      ".webp"
                }
                alt={location.name}
              />
            </div>
            <div>
              <p
                className={`f-s12 font-Visby-cf h-14 mb-1 f-w6 clr-dark-blue text-uppercase ${styleClasses.location_info} mb-2`}
              >
                SELECTED LOCATION
              </p>
              <h4 className={`f-s18 mb-0 h-22 font-Cls text-capilatize`} data-testid="searched-location-name">
                {location.name}
              </h4>
              <span className={`d-block f-s14 f-w5 h-18 font-Visby-cf`} data-testid="searched-location-address">
                {`${location?.address}, ${location?.city}${location?.state ? `, ${location?.state}` : ""}${location?.zip ? `, ${location?.zip}` : ""}`}
                
              </span>
              <span className={`d-block f-s14 h-18 font-Visby-cf`}>
                {location.city_state_zip}
              </span>
              <span className={`d-block f-s14 h-18 font-Visby-cf clr-dark-blue`}>
                {location.phone}
              </span>
            </div>
          </div>

          <div
            className={`${styleClasses.card_info_content} d-flex flex-column justify-content-center align-items-center`}
          >
            <div>
              <FavoriteLocation
                handleFavoriteToggle={(e) =>
                  favoriteButtonHandler(e, location)
                }
                favorite={isFavorite()}
                width={'24'}
              />
            </div>
            <span
            className={`${isGuest && "p-2"}`}
              onClick={(e) => {
                e.stopPropagation();
                if (location.is_live) getInfo(location.name);
              }}
            >
              <Info />
            </span>
            {locationDistance()}
          </div>
        </li>
      </div>
    );
}

export default ActiveLocation